import React from "react";
const InstagramIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13 2c2.21 0 4 1.79 4 4v7c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h7zm0 1H6C4.343 3 3 4.343 3 6v7c0 1.657 1.343 3 3 3h7c1.657 0 3-1.343 3-3V6c0-1.657-1.343-3-3-3z"
  }
), /* @__PURE__ */ React.createElement("circle", { cx: "9.5", cy: "9.5", r: "3", stroke: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.4 5.5c0 .497-.403.9-.9.9s-.9-.403-.9-.9.403-.9.9-.9.9.403.9.9"
  }
)));
var InstagramIcon_default = InstagramIcon;
export {
  InstagramIcon_default as default
};
//# sourceMappingURL=InstagramIcon.js.map
